var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityLow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#oizwutu20a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.6c.5-.3 1.1-.1 1.4.4.3.5.1 1.1-.3 1.3l-5 3c-.3.2-.7.2-1 0l-5-3c-.6-.2-.7-.9-.4-1.3.2-.5.9-.7 1.3-.4l4.5 2.7 4.5-2.7z",
    fill: "#0065FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "oizwutu20a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.25 .5)",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityLow);
export default __webpack_public_path__ + "static/media/priority-low.2b73f27b7d0b6450caa3f61190f7c6eb.svg";
export { ForwardRef as ReactComponent };